import React, { useState, useEffect } from "react";
import get from "lodash.get";
import { useTranslation } from "react-i18next";

import { IBasicTableProps } from "./BasicTable.types";
import { BasicTableStyle } from "./BasicTable.style";
import { REQUEST_STATUS, useRequest } from "hooks";

const BasicTable: React.FC<IBasicTableProps> = ({
  columns,
  dataUrl,
  render,
}) => {
  const [client, res, status, error] = useRequest();
  const [fetchData, setFetchData] = useState<any[]>([]);
  const { t } = useTranslation();

  const fetchDataFunction = async () => {
    if (dataUrl) {
      await client.get(dataUrl);
    }
  };

  useEffect(() => {
    fetchDataFunction();
  }, [render]);

  useEffect(() => {
    if (status === REQUEST_STATUS.success) {
      setFetchData(get(res, "data", []));
    }
  }, [status]);

  return (
    <BasicTableStyle>
      <div className="table-scroll">
        <table className="table">
          <thead>
            <tr>
              <td>№</td>
              {columns.map((column: any) => (
                <td>{column?.title}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {fetchData?.map((item: any, index: number) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {columns.map((column, index) =>
                  column.renderItem ? (
                    <td key={index}>
                      {column.renderItem(item, column, index)}
                    </td>
                  ) : (
                    <td key={index}>{get(item, `${column.dataKey}`)}</td>
                  )
                )}
              </tr>
            ))}
            {!fetchData?.length && (
              <tr>
                <td className="data-not-found">{t("COMMON.DATA_NOT_FOUND")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </BasicTableStyle>
  );
};

export default BasicTable;
